import {
  IResourceComponentsProps,
  useNavigation,
  useShow,
} from "@pankod/refine-core";
import React from 'react'
import { UserManagementTable } from "components/usermanagement";
export const UserManagementList: React.FC<IResourceComponentsProps> = () => {
  const { show } = useNavigation();
  return <UserManagementTable />;
};
